/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
ux-popover-panel-arrow {
  pointer-events: none;
}

.ux-popover-panel-arrow {
  border: var(--ux-popover-panel-arrow-length) solid transparent;
  height: 0;
  position: absolute;
  width: 0;
}
[data-popover-placement^=bottom] .ux-popover-panel-arrow {
  border-top-width: 0;
  left: var(--ux-popover-panel-arrow-inset);
  top: calc(var(--ux-popover-panel-arrow-length) * -1);
}
[data-popover-placement^=bottom] .ux-popover-panel-arrow.ux-popover-panel-arrow__border {
  border-bottom-color: var(--ux-popover-panel-border-color);
}
[data-popover-placement^=bottom] .ux-popover-panel-arrow.ux-popover-panel-arrow__fill {
  border-bottom-color: var(--ux-popover-panel-bg-color);
  transform: translateY(calc(var(--ux-popover-panel-border-width) * 1.414));
}
[data-popover-placement^=top] .ux-popover-panel-arrow {
  border-bottom-width: 0;
  bottom: calc(var(--ux-popover-panel-arrow-length) * -1);
  left: var(--ux-popover-panel-arrow-inset);
}
[data-popover-placement^=top] .ux-popover-panel-arrow.ux-popover-panel-arrow__border {
  border-top-color: var(--ux-popover-panel-border-color);
}
[data-popover-placement^=top] .ux-popover-panel-arrow.ux-popover-panel-arrow__fill {
  border-top-color: var(--ux-popover-panel-bg-color);
  transform: translateY(calc(var(--ux-popover-panel-border-width) * -1.414));
}
[data-popover-placement=top] .ux-popover-panel-arrow, [data-popover-placement=bottom] .ux-popover-panel-arrow {
  left: 50%;
  margin-left: calc(var(--ux-popover-panel-arrow-length) * -1);
}
[data-popover-placement=top-end] .ux-popover-panel-arrow, [data-popover-placement=bottom-end] .ux-popover-panel-arrow {
  left: auto;
  right: var(--ux-popover-panel-arrow-inset);
}
[data-popover-placement^=right] .ux-popover-panel-arrow {
  border-left-width: 0;
  left: calc(var(--ux-popover-panel-arrow-length) * -1);
  top: var(--ux-popover-panel-arrow-inset);
}
[data-popover-placement^=right] .ux-popover-panel-arrow.ux-popover-panel-arrow__border {
  border-right-color: var(--ux-popover-panel-border-color);
}
[data-popover-placement^=right] .ux-popover-panel-arrow.ux-popover-panel-arrow__fill {
  border-right-color: var(--ux-popover-panel-bg-color);
  transform: translateX(calc(var(--ux-popover-panel-border-width) * 1.414));
}
[data-popover-placement^=left] .ux-popover-panel-arrow {
  border-right-width: 0;
  right: calc(var(--ux-popover-panel-arrow-length) * -1);
  top: var(--ux-popover-panel-arrow-inset);
}
[data-popover-placement^=left] .ux-popover-panel-arrow.ux-popover-panel-arrow__border {
  border-left-color: var(--ux-popover-panel-border-color);
}
[data-popover-placement^=left] .ux-popover-panel-arrow.ux-popover-panel-arrow__fill {
  border-left-color: var(--ux-popover-panel-bg-color);
  transform: translateX(calc(var(--ux-popover-panel-border-width) * -1.414));
}
[data-popover-placement=right] .ux-popover-panel-arrow, [data-popover-placement=left] .ux-popover-panel-arrow {
  margin-top: calc(var(--ux-popover-panel-arrow-length) * -1);
  top: 50%;
}
[data-popover-placement=left-end] .ux-popover-panel-arrow, [data-popover-placement=right-end] .ux-popover-panel-arrow {
  bottom: var(--ux-popover-panel-arrow-inset);
  top: auto;
}